import { render } from "./add_support.vue?vue&type=template&id=0a79ddea"
import script from "./add_support.vue?vue&type=script&lang=js"
export * from "./add_support.vue?vue&type=script&lang=js"

import "./add_support.vue?vue&type=style&index=0&id=0a79ddea&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__